/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Reason an RFC 9728 protected resource metadata probe was unavailable. Surfaced when available is false.
 */
export type ProtectedResourceMetadataUnavailable = {
  /**
   * Machine-readable failure code (e.g. not_found, http_error, transport_error, timeout, malformed, host_blocked, invalid_url). Intentionally a free-form string so adding new failure modes is not a breaking SDK change.
   */
  code: string;
  /**
   * Human-readable summary of the unavailability reason, composed by the backend. Dashboards should render verbatim.
   */
  message: string;
};

/** @internal */
export const ProtectedResourceMetadataUnavailable$inboundSchema: z.ZodMiniType<
  ProtectedResourceMetadataUnavailable,
  unknown
> = z.object({
  code: z.string(),
  message: z.string(),
});

export function protectedResourceMetadataUnavailableFromJSON(
  jsonString: string,
): SafeParseResult<ProtectedResourceMetadataUnavailable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ProtectedResourceMetadataUnavailable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ProtectedResourceMetadataUnavailable' from JSON`,
  );
}
